import { Users } from 'lucide-react';
import AdminUserManagement from './AdminUserManagement';

export default function AdminUsers() {
  return (
    <AdminUserManagement
      allowRoleFilter
      title="Users"
      subtitle="View and manage all registered users"
      Icon={Users}
      emptyText="No users found"
    />
  );
}
